module.exports = __webpack_public_path__ + "static/media/chuveito.4e137d0f.svg";